export class Versions {
    constructor() {}

    public assortmentExcel: string = '1.3.0';
    public changeBufferExcel: string = '1.3.0';
    public bufferTableExcel: string = '1.4.4';
    public marketingPurchase: string = '1.3.6';
    public orders: string = '1.4.34';
    public stocks: string = '1.2.24';
    public itemProperties: string = '1.5.14';
    public chart: string = '1.0.5';
    public supplySchedules: string = '0.5.7';
    public stocksPresetEditor: string = '1.0.0';
    public vacation: string = '1.0.2';
    public manualOrders: string = '1.2.4';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vesions.ts